
export const PAGINATION_PER_PAGE = 15;

export const ALLOW_RECHARGE_ONE = process.env.REACT_APP_ALLOW_RECHARGE_ONE;
export const ALLOW_RECHARGE_TWO = process.env.REACT_APP_ALLOW_RECHARGE_TWO;
export const ALLOW_PANCARD = process.env.REACT_APP_ALLOW_PANCARD;

export const ALLOW_AEPS_EKO = process.env.REACT_APP_ALLOW_AEPS_EKO;
export const ALLOW_AEPS_BANKIT = process.env.REACT_APP_ALLOW_AEPS_BANKIT;
export const ALLOW_PAYMENT_REQ = process.env.REACT_APP_ALLOW_PAYMENT_REQ;

export const ALLOW_EXPRESS_PAYOUT = process.env.REACT_APP_ALLOW_EXPRESS_PAYOUT;
export const ALLOW_PAYOUT = process.env.REACT_APP_ALLOW_PAYOUT;

export const SUPPORT_NUMBER = process.env.REACT_APP_SUPPORT_NUMBER;
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;


export const ECO_DEVELOPER_KEY = process.env.REACT_APP_ECO_DEVELOPER_KEY;
export const ECO_SECRIT_KEY = process.env.REACT_APP_ECO_SECRIT_KEY;
export const ECO_ENVIRONMENT = process.env.REACT_APP_ECO_ENVIRONMENT;
export const ECO_INITITATOR_ID = process.env.REACT_APP_ECO_INITITATOR_ID;
export const ECO_CALLBACK_URL = process.env.REACT_APP_ECO_CALLBACK_URL;
export const ECO_API_URL = process.env.REACT_APP_ECO_API_URL;
export const ECO_TITLE = process.env.REACT_APP_ECO_TITLE;
export const ECO_LOGO = process.env.REACT_APP_ECO_LOGO;

export const ALLOW_BBPS = process.env.REACT_APP_ALLOW_BBPS;

export const WLOGO = process.env.REACT_APP_WLOGO;

export const SERVER_IMG_PATH = process.env.REACT_APP_SERVER_IMG;




